import { useMemo, useState } from "react";
import { Button, Form, Space } from "antd";

import DataTable from "../../DataTable";

interface StepProps {
  gotoStep: Function;
  current: number;
  payments: any;
  member: any;
  claimType?: "Internal" | "External";
}

const Checks: React.FC<StepProps> = ({
  gotoStep,
  current,
  payments,
  member,
  claimType = "Internal",
}) => {
  const outstandingPremium = Number(member?.Policy?.OutstandingPremium ?? 0);
  const isInWaitingPeriod = Number.isFinite(outstandingPremium)
    ? outstandingPremium < 0
    : false;

  const [state] = useState({
    loading: true,
    activeKey: "1",
    pagination: {
      pageSize: 5,
      position: ["bottomRight"],
      total: 0,
      current: 1,
      hideOnSinglePage: true,
    },
    searchItem: "",
  });

  const paymentColumns = useMemo(
    () => [
      {
        title: "Payment ID",
        dataIndex: "id",
        render: (id: string) => id.toUpperCase(),
      },
      {
        title: "Payment Provider",
        dataIndex: "PaymentProvider",
      },
      {
        title: "Payment Date",
        dataIndex: "Date",
      },
      {
        title: "Payment Type",
        dataIndex: "Type",
      },
      {
        title: "Payment Amount",
        dataIndex: "Amount",
      },
      {
        title: "Payment Reference",
        dataIndex: "Reference",
      },
    ],
    []
  );

  const handleContinue = () => {
    // External flow skips Covered Live (step 2) → Details (step 3).
    if (claimType === "External") {
      gotoStep(3);
      return;
    }
    gotoStep(current + 1);
  };

  const balanceDisplay = Number.isFinite(outstandingPremium)
    ? outstandingPremium.toFixed(2)
    : "0.00";

  const content = (
    <>
      <Space
        size={"large"}
        direction="vertical"
        style={{ width: "100%", textAlign: "center", margin: "0 0 16px 0" }}
      >
        <h2 style={{ color: "#f04f05", padding: "16px 0" }}>
          Check Payments and Waiting Period.
        </h2>
      </Space>
      <hr />

      <Space
        size={"large"}
        direction="vertical"
        style={{
          width: "100%",
          textAlign: "center",
          margin: "16px 0 24px 0",
        }}
      >
        <h3 style={{ padding: "16px 0" }}>Payments</h3>
        <DataTable
          persistKey="claim-checks-payments"
          dataSource={payments}
          columns={paymentColumns}
          loading={""}
          pagination={state.pagination}
          onChange={""}
        />
      </Space>

      <hr />
      <Space
        size={"large"}
        direction="vertical"
        style={{ width: "100%", margin: "16px 0", textAlign: "center" }}
      >
        <h3 style={{ padding: "16px 0" }}>Policy Information</h3>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "30%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p style={{ fontWeight: "bold" }}>Policy Number.</p>
            <p>{member?.Policy?.PolicyNumber}</p>
          </div>
          <div
            style={{
              width: "30%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p style={{ fontWeight: "bold" }}>Main Member Name.</p>
            <p>{member?.Name}</p>
          </div>
          <div
            style={{
              width: "30%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p style={{ fontWeight: "bold" }}>Main Member Surname.</p>
            <p>{member?.Surname}</p>
          </div>
          <div
            style={{
              width: "30%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p style={{ fontWeight: "bold" }}>Main Member Cellphone.</p>
            <p>{member?.Cellphone}</p>
          </div>
          <div
            style={{
              width: "30%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p style={{ fontWeight: "bold" }}>Policy Account Balance</p>
            <p>R {balanceDisplay}</p>
          </div>
          <div
            style={{
              width: "30%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p style={{ fontWeight: "bold" }}>Inception Date</p>
            <p>{member?.InceptionDate}</p>
          </div>
          <div
            style={{
              width: "30%",
              display: "flex",
              padding: "16px 0",
            }}
          >
            {isInWaitingPeriod ? (
              <p style={{ color: "#bd4f4f" }}>
                The policy has outstanding payments and is still in waiting
                period
              </p>
            ) : (
              <p style={{ color: "#5aa665" }}>
                The policy is all paid up and out of waiting period
              </p>
            )}
          </div>
        </div>
      </Space>
      <Form.Item wrapperCol={{ offset: 8, span: 8 }}>
        <Space
          size={"large"}
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <Button
            className="claim-continue-btn"
            block
            size="large"
            onClick={handleContinue}
          >
            Continue
          </Button>
        </Space>
      </Form.Item>
    </>
  );

  return content;
};

export default Checks;
